<template>
  <FocusTrap
  :initial-focus="() => $refs.closePopup"
  :escapeDeactivates="true"
  @deactivate="onDeactivateFocusTrap()"
  ref="focusTrapHelpPopup">
  <div class="z-30 fixed w-full h-full top-0 left-0 flex items-center justify-center bg-gray-400 bg-opacity-50 mx-auto text-left">
    <div v-click-outside="hidePopup" class="xhtml-string xl:w-1/4 lg:w-1/2 md:w-2/3 sm:w-full inset-0 my-4 p-8 max-h-screen overflow-y-scroll md:overflow-hidden bg-bluegray-200">
      <div class="flex justify-between h-6 mb-8">
        <h1 class="font-semibold text-xl flex-row pb-9">{{$t('helpPopup.header')}}</h1>
        <button @click="hidePopup" class="cursor-pointer">
          <font-awesome-icon class="font-semibold text-xl" icon="times" />
        </button>
      </div>
      <div class="w-full text-base mb-8" v-html="text" />
      <div class="flex justify-start">
        <button class="btn btn--secondary" @click="hidePopup" :title="$t('window.close.description.popup')" ref="closePopup">{{$t('window.close.text')}}</button>
      </div>
    </div>
  </div>
  </FocusTrap>
</template>

<script>
  import vClickOutside from 'click-outside-vue3';
  import { FocusTrap } from 'focus-trap-vue';
  import { HIDE_MODAL } from '@/store/modules/appContext';

  export default {
    components: {
      FocusTrap,
    },
    props: {
      text: {
        type: String,
        required: true,
      },
    },
    directives: {
      clickOutside: vClickOutside.directive,
    },
    methods: {
      hidePopup() {
        this.$emit('close');
        this.$store.commit(HIDE_MODAL);
      },
      onDeactivateFocusTrap() {
        this.hidePopup();
      },
    },
  };
</script>
